import React from 'react';

import Style from './restriced.module.css';

import ImageLoader from '../../molecules/Image';

function RestrictedPage({ title }) {
  return (
    <div className={Style.restricted}>
      <ImageLoader alt='Restrict Icon' height={42} src='/images/restrict-icon.svg' width={42} />
      <h3>No Access</h3>
      <p>{title}</p>
    </div>
  );
}

RestrictedPage.defaultProps = {
  title: 'You don’t have access to this page'
};

export default RestrictedPage;
